// extracted by mini-css-extract-plugin
export default {"main":"Video_main__lP+hS"};